const cardColors : {[key:string] : string} = {
    RED:"red",
    BLUE:"blue",
    GREEN:"green",
    YELLOW:"yellow",

 }
 export default cardColors